import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Heart, Play } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import { useAuth } from "../context/AuthContext";
import BookCard from "../components/BookCard";
import { Button } from "../components/ui/button";
import api from "../api";

export default function Wishlist() {
  const { t } = useLang();
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [books, setBooks] = useState([]);

  useEffect(() => {
    // `user` is null while the session is still resolving, so redirecting on it
    // threw signed-in listeners out to /login whenever they opened this page
    // directly or refreshed it.
    if (loading) return;
    if (!user) {
      navigate(`/login?next=/wishlist`, { replace: true });
      return;
    }
    api.get("/me/wishlist").then((r) => setBooks(r.data)).catch(() => {});
  }, [user, loading, navigate]);

  return (
    <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 py-8 animate-float-up min-h-[60vh]">
      <div className="flex items-center gap-3 mb-8">
        <div className="w-11 h-11 rounded-xl bg-brand-500/15 border border-brand-500/30 flex items-center justify-center">
          <Heart className="w-5 h-5 text-brand-400" />
        </div>
        <div>
          <h1 className="font-display text-3xl sm:text-4xl font-semibold tracking-tight">{t("wishlist")}</h1>
          <p className="text-sm text-muted-foreground">{books.length} {t("results")}</p>
        </div>
      </div>

      {books.length === 0 ? (
        <div className="rounded-2xl border border-dashed border-border py-24 text-center">
          <Heart className="w-12 h-12 text-muted-foreground/50 mx-auto mb-4" />
          <p className="text-muted-foreground">Your Wish List is empty.</p>
          <Button onClick={() => navigate("/browse")} className="mt-6 bg-brand-500 hover:bg-brand-400 text-brand-950 font-semibold rounded-full px-7">
            {t("hero_explore")}
          </Button>
        </div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-x-5 gap-y-8">
          {books.map((b) => (
            <BookCard key={b.id} book={b} width="w-full" />
          ))}
        </div>
      )}
    </div>
  );
}
